<template>
    <div class="page-wrapper">
      <div class="pc-version">
        <div
          class="menu-table-container"
          v-loading="loading"
          element-loading-text="拼命加载中..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.3)"
        >
          <div class="search-bar">
            <el-button type="success" icon="el-icon-plus" @click="handlePcAdd">
              添加配置
            </el-button>
          </div>
          <el-table
            height="900"
            :data="tableData"
            border
            stripe
            style="width: 100%; margin-top: 20px"
          >
            <el-table-column label="ID" prop="id" width="80" align="center" />
            <el-table-column label="用户ID" prop="user_id" width="120" align="center" />
            <el-table-column label="用户编号" prop="user_no" width="180" align="center" />
            <el-table-column label="昵称" prop="nickname" width="140" align="center" />
            <el-table-column label="赠送限额" prop="give_amount" width="140" align="center" />
            <el-table-column label="创建时间" prop="created_at" width="180" />
            <el-table-column label="更新时间" prop="updated_at" width="180" />
            <el-table-column
              label="操作"
              fixed="right"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click.stop="handlePcEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  style="color: #f56c6c"
                  @click.stop="handlePcDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageInfo.total"
            style="margin-top: 20px; text-align: right"
          ></el-pagination>

          <el-dialog
            :title="pcDialogType == 'add' ? '添加用户赠送限额配置' : '编辑用户赠送限额配置'"
            :visible.sync="pcDialogVisible"
            width="500px"
            @close="pcResetForm"
            append-to-body
          >
            <el-form
              :model="pcForm"
              :rules="addRules"
              ref="pcFormRef"
              label-width="110px"
            >
              <el-form-item label="用户ID" prop="user_id">
                <el-input
                  v-model.number="pcForm.user_id"
                  placeholder="请输入用户ID"
                  style="width: 300px"
                />
              </el-form-item>
              <el-form-item label="赠送限额" prop="give_amount">
                <el-input
                  v-model.number="pcForm.give_amount"
                  placeholder="请输入赠送限额"
                  style="width: 300px"
                />
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button @click="pcDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
            </div>
          </el-dialog>
        </div>
      </div>

      <div class="mobile-version">
        <div
          class="mobile-goods-container"
          v-loading="loading"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0,0,0,0.4)"
        >
          <div class="mobile-search-group">
            <div style="display: flex; gap: 8px; margin-top: 8px">
              <el-button
                type="success"
                plain
                round
                @click="handleMobileAdd"
                style="flex: 1"
              >
                添加配置
              </el-button>
            </div>
          </div>
          <div class="mobile-card-list">
            <div
              class="mobile-card"
              v-for="item in tableData"
              :key="item.id"
            >
              <div class="card-header">
                <div class="info">
                  <div class="title">用户ID：{{item.user_id}}</div>
                  <div class="meta">
                    ID:{{ item.id }}｜{{item.nickname}}
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div>用户编号：{{item.user_no}}</div>
                <div>赠送限额：{{item.give_amount}}</div>
                <div>创建时间：{{item.created_at}}</div>
              </div>
              <div class="card-footer">
                <el-button
                  size="mini"
                  type="primary"
                  round
                  @click.stop="handleMobileEdit(item)"
                >
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  round
                  @click.stop="handleMobileDelete(item)"
                >
                  删除
                </el-button>
              </div>
            </div>
          </div>
          <div style="text-align: center; margin-top: 15px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchParams.page"
              :page-size="searchParams.page_size"
              layout="total, prev, pager, next, jumper"
              :total="pageInfo.total"
            />
          </div>

          <el-dialog
            :title="mobileDialogType == 'add' ? '添加用户赠送限额配置' : '编辑用户赠送限额配置'"
            :visible.sync="mobileDialogVisible"
            width="95%"
            top="10vh"
            custom-class="mobile-dialog"
            append-to-body
          >
            <el-form
              :model="mobileForm"
              :rules="addRules"
              ref="mobileFormRef"
              label-width="90px"
              size="small"
            >
              <el-form-item label="用户ID" prop="user_id">
                <el-input
                  v-model.number="mobileForm.user_id"
                  placeholder="用户ID"
                  size="medium"
                />
              </el-form-item>
              <el-form-item label="赠送限额" prop="give_amount">
                <el-input
                  v-model.number="mobileForm.give_amount"
                  placeholder="赠送限额"
                  size="medium"
                />
              </el-form-item>
            </el-form>
            <div
              slot="footer"
              style="display: flex; justify-content: flex-end; gap: 10px"
            >
              <el-button size="medium" @click="mobileDialogVisible = false">取消</el-button>
              <el-button type="primary" size="medium" @click="mobileSubmitForm">保存</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </template>

  <script>
  import api from "../../api/api.js";
  export default {
    name: "UserGiveLimitPanel",
    data() {
      return {
        loading: false,
        tableData: [],
        pageInfo: { total: 0 },
        searchParams: {
          page: 1,
          page_size: 10,
        },
        addRules: {
          user_id: [
            { required: true, message: "请输入用户ID", trigger: "blur" },
            { type: "number", message: "用户ID必须为数字" },
          ],
          give_amount: [
            { required: true, message: "请输入赠送限额", trigger: "blur" },
            { type: "number", message: "赠送限额必须为数字" },
          ],
        },
        // PC
        pcDialogVisible: false,
        pcDialogType: "add",
        pcForm: {
          record_id: "",
          user_id: "",
          give_amount: "",
        },
        // 移动端
        mobileDialogVisible: false,
        mobileDialogType: "add",
        mobileForm: {
          record_id: "",
          user_id: "",
          give_amount: "",
        },
      };
    },
    created() {
      this.getList();
    },
    methods: {
      // 列表
      getList() {
        this.loading = true;
        api.userGiveLimit
          .index({ params: this.searchParams })
          .then((res) => {
            if (res.data.code == 1000) {
              this.tableData = res.data.data.data;
              this.pageInfo.total = res.data.data.total;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },

      // PC
      handlePcAdd() {
        this.pcDialogType = "add";
        this.pcResetForm();
        this.pcDialogVisible = true;
      },
      handlePcEdit(row) {
        this.pcDialogType = "edit";
        this.pcForm = {
          record_id: row.id,
          user_id: row.user_id,
          give_amount: row.give_amount,
        };
        this.pcDialogVisible = true;
      },
      async handlePcDelete(row) {
  await this.$confirm("此操作将永久删除该配置, 是否继续?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).catch(() => {
    this.$message("已取消删除");
    return Promise.reject();
  });
  this.loading = true;
  api.userGiveLimit.del({ record_id: row.id })
    .then((res) => {
      if (res.data.code == 1000) {
        this.getList();
      }
    })
    .finally(() => {
      this.loading = false;
    });
},
      pcResetForm() {
        this.pcForm = {
          record_id: "",
          user_id: "",
          give_amount: "",
        };
        this.$nextTick(() => {
          if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
        });
      },
      pcSubmitForm() {
        this.$refs.pcFormRef.validate((valid) => {
          if (!valid) return;
          this.loading = true;
          let fn;
          if (this.pcDialogType == "add") {
            fn = api.userGiveLimit.add;
          } else {
            fn = api.userGiveLimit.edit;
          }
          fn(this.pcForm)
            .then((res) => {
              if (res.data.code == 1000) {
                this.pcDialogVisible = false;
                this.getList();
              }
            })
            .finally(() => {
              this.loading = false;
            });
        });
      },

      // 移动端
      handleMobileAdd() {
        this.mobileDialogType = "add";
        this.mobileResetForm();
        this.mobileDialogVisible = true;
      },
      handleMobileEdit(row) {
        this.mobileDialogType = "edit";
        this.mobileForm = {
          record_id: row.id,
          user_id: row.user_id,
          give_amount: row.give_amount,
        };
        this.mobileDialogVisible = true;
      },
      async handleMobileDelete(row) {
  await this.$confirm("此操作将永久删除该配置, 是否继续?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).catch(() => {
    this.$message("已取消删除");
    return Promise.reject();
  });
  this.loading = true;
  api.userGiveLimit.del({ record_id: row.id })
    .then((res) => {
      if (res.data.code == 1000) {
        this.getList();
      }
    })
    .finally(() => {
      this.loading = false;
    });
},
      mobileResetForm() {
        this.mobileForm = {
          record_id: "",
          user_id: "",
          give_amount: "",
        };
        this.$nextTick(() => {
          if (this.$refs.mobileFormRef) this.$refs.mobileFormRef.clearValidate();
        });
      },
      mobileSubmitForm() {
        this.$refs.mobileFormRef.validate((valid) => {
          if (!valid) return;
          this.loading = true;
          let fn;
          if (this.mobileDialogType == "add") {
            fn = api.userGiveLimit.add;
          } else {
            fn = api.userGiveLimit.edit;
          }
          fn(this.mobileForm)
            .then((res) => {
              if (res.data.code == 1000) {
                this.mobileDialogVisible = false;
                this.getList();
              }
            })
            .finally(() => {
              this.loading = false;
            });
        });
      },

      // 分页
      handleSizeChange(val) {
        this.searchParams.page_size = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.searchParams.page = val;
        this.getList();
      },
    },
  };
  </script>

  <style scoped>
  .menu-table-container {
    padding: 20px;
  }
  .search-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .mobile-goods-container {
    padding: 12px;
    box-sizing: border-box;
  }
  .mobile-search-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;
  }
  .mobile-card-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .mobile-card {
    background: #fff;
    border-radius: 12px;
    padding: 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
  .card-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }
  .info {
    flex: 1;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
  }
  .meta {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
  .card-body {
    font-size: 13px;
    color: #666;
    line-height: 1.8;
    margin-bottom: 10px;
  }
  .card-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
  }
  </style>



// WEBPACK FOOTER //
// src/pages/signPanel/userGiveLimit.vue